import { lazy } from 'react';
import i18next from 'i18next';
import { ClaimsIcon } from '@shared/ui/icons';
import permissions from '@shared/config/permissions';

const Claims = lazy(() => import('@pages/claims'));
const EditClaim = lazy(() => import('@pages/claim-edit'));

// const CLAIM_ROUTE_LIST_DS = {
//   path: '/:currentAccountUuid/accounts/:accountUuid/claims',
//   exact: true,
//   additional: {
//     component: Claims,
//     title: i18next.t('titles:claimsReporting'),
//     protected: true,
//     icon: ClaimsIcon,
//     permission: permissions.CLAIMS_GET,
//   },
// };

const CLAIM_ROUTE_LIST = {
  path: '/:currentAccountUuid/claims',
  exact: true,
  additional: {
    component: Claims,
    title: i18next.t('titles:claimsReporting'),
    protected: true,
    icon: ClaimsIcon,
    permission: permissions.CLAIMS_GET,
    getUrl: '/accounts/:currentAccountUuid/claims',
    breadcrumb: {
      isRoot: true,
      label: ({ state }) => state.i18n?.en?.titles?.claimsReporting || 'Claims',
    },
  },
};

const CLAIM_ROUTE_EDIT_DS = {
  path: '/:currentAccountUuid/accounts/:accountUuid/claims/:claimUuid',
  exact: true,
  parentRoute: CLAIM_ROUTE_LIST, //CLAIM_ROUTE_LIST_DS,
  additional: {
    component: EditClaim,
    title: i18next.t('titles:editClaim'),
    protected: true,
    icon: ClaimsIcon,
    permission: permissions.CLAIMS_GET,
    breadcrumb: {
      isRoot: false,
      parentPath: '/:currentAccountUuid/claims',
      label: ({ state }) => state.i18n?.en?.titles?.editClaim || 'Claim',
      replaceSibling: true,
    },
  },
};

const CLAIM_ROUTE_EDIT = {
  path: '/:currentAccountUuid/claims/:claimUuid',
  exact: true,
  parentRoute: CLAIM_ROUTE_LIST,
  additional: {
    component: EditClaim,
    title: i18next.t('titles:editClaim'),
    protected: true,
    icon: ClaimsIcon,
    permission: permissions.CLAIMS_GET,
    breadcrumb: {
      isRoot: false,
      parentPath: '/:currentAccountUuid/claims',
      label: ({ state }) => state.i18n?.en?.titles?.editClaim || 'Claim',
      replaceSibling: true,
    },
  },
};

export const CLAIM_ROUTES = {
  // ------- For child accounts ------
  // listDS: CLAIM_ROUTE_LIST_DS,
  editDS: CLAIM_ROUTE_EDIT_DS,

  // ------- For current accounts ------
  list: CLAIM_ROUTE_LIST,
  edit: CLAIM_ROUTE_EDIT,
};
